/**
 * Shared color palette + helpers for the analytics redesign.
 *
 * Centralises the hex tokens that were previously declared per-file in
 * ChartAnaylysisComponent, ContentAnaylysisComponent, and ValueVsSpendComponent.
 * If a Figma palette swap happens, this is the only place that should change.
 */

// Pastel trio used across donut segments, stacked bars, and legend chips.
export const PASTEL_PEACH = '#FCDCB9';
export const PASTEL_GREEN = '#B8F9CF';
export const PASTEL_PINK = '#F3C6E2';
export const PASTEL_YELLOW = '#FFF7CD';
export const PASTEL_BLUE = '#BDECFF';
export const PASTEL_PURPLE = '#F5D9FF';

// Neutrals.
export const TEXT_MUTED = '#9B919D';
export const TEXT_DEFAULT = '#383838';
export const TEXT_HEADING = '#121111';
export const BORDER_DEFAULT = '#E5E9EB';
export const TEXT_PURPLE = '#2F1869';

// Value-VS-Spend stacked-bar segments. The dot color = bar segment fill.
// Chip text uses TEXT_PURPLE.
export const SEGMENT_COLORS = {
  cgc: PASTEL_PINK,
  emv: PASTEL_GREEN,
  sales: PASTEL_PEACH,
} as const;

// Lighter tints of the segment colors, used as the legend chip background so
// the percent chip reads softer than the saturated dot/bar fill.
export const SEGMENT_CHIP_COLORS = {
  cgc: '#F8DDEE',
  emv: '#D4FBE2',
  sales: '#FDEAD5',
} as const;

// Chart Analysis line/area chart colors.
export const EMV_COLOR = '#0FAF62';
export const SALES_COLOR = '#F0C030';
export const SPENDING_COLOR = '#7EC8E8';

// ROAS line colors (Instagram/TikTok mapped to brand colors, total stays brand-green).
export const ROAS_ALL_COLOR = '#0FAF62';
export const ROAS_INSTAGRAM_COLOR = '#BF33B2';
export const ROAS_TIKTOK_COLOR = '#FF004F';

// Content Analysis pie (post/reel/story).
export const CONTENT_PIE_COLORS = {
  post: '#B9F1DA',
  reel: '#F5D9FF',
  story: '#CDF3F4',
} as const;

// Content Analysis engagement bar legend (view/like/comment).
export const ENGAGEMENT_COLORS = {
  view: PASTEL_BLUE, // #BDECFF
  like: '#FEC7CB',
  comments: PASTEL_YELLOW, // #FFF7CD
} as const;
